import styled, { css } from "styled-components";

export const GiftCardPageRoot = styled.div(
    ({ theme }) => css`
        display: flex;
        flex-direction: column;
        row-gap: ${theme.spacing["4"]};
    `,
);

export const SearchBarRoot = styled.div(
    () => css`
        display: grid;
        grid-template-columns: 1fr 100px;
        gap: 15px;
    `,
);

export const PurchasedBtn = styled.button(
    ({ theme }) => css`
        background-color: #30C3A3;
        padding: 0px 20px;
        border-radius: 25px;
        color: white;
        font-weight: bold;
        font-size: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        column-gap: ${theme.spacing["2"]};
        border: none;
        cursor: pointer;
    `,
);
